import React, { useEffect } from "react";
import { Col, Form, Input, InputNumber, Modal, Row, Select, DatePicker } from "antd";

import { PRICE_UNITS } from "../constants";

const { RangePicker } = DatePicker;

const PricePeriodCreateModal = ({ open, loading, vendors, onCancel, onSubmit }) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (!open) {
            form.resetFields();
            return;
        }

        form.setFieldsValue({
            price_currency: "USD",
            price_unit: "MT",
        });
    }, [form, open]);

    const handleOk = async () => {
        const values = await form.validateFields();
        const { period_range, ...restValues } = values;

        await onSubmit({
            ...restValues,
            period_start: period_range[0].format("YYYY-MM-DD"),
            period_end: period_range[1].format("YYYY-MM-DD"),
        });
    };

    return (
        <Modal
            title="新建价格周期"
            open={open}
            onOk={handleOk}
            onCancel={onCancel}
            confirmLoading={loading}
            width={560}
            destroyOnClose
        >
            <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
                <Form.Item name="vendor_id" label="供应商" rules={[{ required: true, message: "请选择供应商" }]}>
                    <Select placeholder="选择供应商" showSearch optionFilterProp="children">
                        {vendors.map((vendor) => (
                            <Select.Option key={vendor.id} value={vendor.id}>
                                {vendor.name}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item name="airport_code" label="机场代码" rules={[{ required: true, message: "请输入机场 IATA 代码" }]}>
                    <Input placeholder="如 HKG" maxLength={10} style={{ textTransform: "uppercase" }} />
                </Form.Item>
                <Form.Item name="period_range" label="价格周期" rules={[{ required: true, message: "请选择周期日期范围" }]}>
                    <RangePicker style={{ width: "100%" }} />
                </Form.Item>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item name="our_calculated_price" label="我方预算价">
                            <InputNumber placeholder="选填" min={0} step={0.01} style={{ width: "100%" }} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="supplier_quoted_price" label="供应商确认价">
                            <InputNumber placeholder="选填" min={0} step={0.01} style={{ width: "100%" }} />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item name="price_currency" label="币种">
                            <Input placeholder="USD" maxLength={10} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="price_unit" label="计价单位">
                            <Select>
                                {PRICE_UNITS.map((unit) => (
                                    <Select.Option key={unit} value={unit}>
                                        {unit}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item name="remarks" label="备注">
                    <Input.TextArea rows={2} placeholder="可选备注" />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default PricePeriodCreateModal;
